import React, { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// Load API Key from environment variables
const mapboxToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

if (!mapboxToken) {
  console.error("Mapbox access token is missing. Please check your .env file.");
} else {
  mapboxgl.accessToken = mapboxToken;
  console.log("Token loaded:", mapboxToken.slice(0, 10) + "..."); // Show first 10 chars of token
}

const MapBox = ({ zoom = 10 }) => {
  const mapContainerRef = useRef(null);
  const [userLocation, setUserLocation] = useState({
    latitude: 37.7749, // Default to San Francisco
    longitude: -122.4194,
  });

  useEffect(() => {
    // Check if Geolocation API is available
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting user location:", error);
        },
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    if (!mapboxgl.accessToken) {
      console.error("Mapbox access token is not set.");
      return;
    }

    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [userLocation.longitude, userLocation.latitude],
      zoom: zoom,
    });

    // Add marker for user's location
    new mapboxgl.Marker()
      .setLngLat([userLocation.longitude, userLocation.latitude])
      .addTo(map);

    return () => map.remove();
  }, [userLocation, zoom]);

  if (!mapboxToken) {
    return (
      <div className="w-full h-[400px] rounded-lg shadow-lg bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-500 font-bold">Map loading failed</p>
          <p className="text-sm text-gray-600">
            Environment variable not found
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={mapContainerRef}
      className="w-full h-[400px] rounded-lg shadow-lg"
    />
  );
};

export default MapBox;
